"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.semverCompare = void 0;
/**
 *
 * @param ver1 - first version
 * @param ver2 - second version
 */
function semverCompare(ver1, ver2) {
    const split1 = ver1.split(".");
    const split2 = ver2.split(".");
    if (split1.length !== split2.length) {
        throw new Error("bad format for semver compare");
    }
    let res = "equal";
    split1.forEach((v, i) => {
        if (Number(v) > Number(split2[i])) {
            res = "greater";
        }
        if (Number(v) < Number(split2[i])) {
            res = "less";
        }
    });
    return res;
}
exports.semverCompare = semverCompare;
//# sourceMappingURL=semverCompare.js.map